// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-row[data-v-e8215f78] {\n    margin-left: 0;\n    margin-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
